import classNames from 'classnames'
import { FunctionComponent } from 'react'
import { SourceName } from 'types'

import classes from './CircledImage.module.scss'

interface ImageProps {
  width?: number
  height?: number
  role: string
}

interface CircledImageProps {
  logoName: SourceName
  className?: string
  Image: FunctionComponent<ImageProps>
  imageContainerSize: number
  imageSize: number
}

export const CircledImage: FunctionComponent<CircledImageProps> = ({
  Image,
  logoName,
  className,
  imageContainerSize,
  imageSize,
  ...props
}) => {
  return (
    <div className={classNames(classes.CircledImage, className)} {...props}>
      <div
        className={classNames(classes.CircledImage__ImageContainer)}
        style={{ width: imageContainerSize, height: imageContainerSize }}
      >
        <Image
          width={imageSize}
          height={imageSize}
          role="img"
          aria-label={`${logoName} image`}
        />
      </div>
    </div>
  )
}
